import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from "Common/Footer";
import { Button, Card } from "antd";
import "./complaintDetail.scss";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { formatDateTime } from "Common/DateTimeFormat";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { message } from "antd";
import {
  ComplaintStatusEnum,
  ComplaintStatusLabel,
} from "Constants/Enums/Complaint/ComplaintStatusEnum";
import { ComplaintTypeLabel, ComplaintTypeEnum } from "Constants/Enums/Complaint/ComplaintTypeEnum";

function ComplaintDetail() {
  const location = useLocation();
  const { id, complainantEmployeeId } = useParams();
  const complaintId = id;
  const navigate = useNavigate();

  const [complaintDetail, setComplaintDetail] = useState(null);
  const [correctiveCount, setCorrectiveCount] = useState(0);

  const handleAddCorrectiveAction = () => {
    navigate(`/corrective-action-form/${id}/${complainantEmployeeId}`);
  };

  const handleViewCorrectiveAction = () => {
    navigate(`/view-corrective-action-form/${id}`);
  };

  const handleResolvedClick = async () => {
    try {
      const res = await axiosInstance.post(API.complaint.updateStatus, {
        complaintId: parseInt(complaintId, 10),
        status: 1,
      });

      if (res.status === 200 || res.status === 201) {
        message.success("Complaint marked as resolved successfully! ");
      } else {
        message.warning("Something went wrong while resolving the complaint.");
      }
    } catch (error) {
      console.error("Error resolving complaint:", error);
      message.error("Failed to resolve complaint. Please try later.");
    }
  };

  useEffect(() => {
    async function fetchComplaintDetail() {
      try {
        const response = await axiosInstance.get(API.complaint.getComplaint(id));
        setComplaintDetail(response.data);
        const storedStatus = localStorage.getItem(`complaint_${id}_status`);
      } catch (error) {
        console.error("Error fetching employee detail:", error);
      }
    }
    fetchComplaintDetail();
  }, [id]);

  useEffect(() => {
    async function fetchCorrectiveActions() {
      try {
        const response = await axiosInstance.get(
          `/Complaint/CorrectiveAction/Get-By-Complaint/${id}`
        );

        setCorrectiveCount(
          response.data && Array.isArray(response.data.correctiveActions)
            ? response.data.correctiveActions.length
            : 0
        );
      } catch (error) {
        console.error("Error fetching corrective actions:", error);
        setCorrectiveCount(0);
      }
    }
    if (id) {
      fetchCorrectiveActions();
    }
  }, [id]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <Card
        title="Complaint Detail"
        className="card-professional"
        extra={
          <Button className="btn-back" onClick={() => navigate(-1)}>
            Back
          </Button>
        }
      >
        {complaintDetail && (
          <>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail"> Complainant Full Name </h6>
              <span className="h6-complaintDetail">
                {complaintDetail.complainantFirstName} {"  "} {complaintDetail.complainantLastName}
              </span>
            </div>

            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail"> Complainant Email </h6>
              <span className="h6-complaintDetail">{complaintDetail.complainantEmail}</span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail"> Complainant Phone No </h6>
              <span className="h6-complaintDetail">{complaintDetail.complainantPhone}</span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail">Complaint Title </h6>
              <span className="h6-complaintDetail">{complaintDetail.complaintTypeName}</span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail">Complaint Against Full Name</h6>
              <span className="h6-complaintDetail">
                {complaintDetail.complaintAgainstFirstName} {"  "}
                {complaintDetail.complaintAgainstLastName}
              </span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail"> Complaint Against Email </h6>
              <span className="h6-complaintDetail">{complaintDetail.complaintAgainstEmail}</span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail"> Complaint Against Phone No </h6>
              <span className="h6-complaintDetail">{complaintDetail.complaintAgainstPhone}</span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail">Complaint Detail of Incident</h6>
              <div className="incident-detail">
                <span className="h6-complaintDetail">{complaintDetail.detailOfIncident}</span>
              </div>
            </div>

            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail">Status</h6>
              <span className="h6-complaintDetail">
                {ComplaintStatusLabel[complaintDetail.status]}
              </span>
            </div>
            <div className="complaintAction mb-2">
              <h6 className="h6-complaintDetail">Requested Date</h6>
              <span className="h6-complaintDetail">
                {formatDateTime(complaintDetail.createdOn)}
              </span>
            </div>
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
            >
              {/*  Logic for buttons */}
              {complaintDetail.status === ComplaintStatusEnum.Pending && correctiveCount === 0 && (
                <>
                  <Button className="btn-primary" onClick={handleAddCorrectiveAction}>
                    Add Corrective Action
                  </Button>
                  <Button type="default" style={{ marginLeft: 8 }} onClick={handleResolvedClick}>
                    Close Without Action
                  </Button>
                </>
              )}

              {complaintDetail.status === ComplaintStatusEnum.Pending && correctiveCount > 0 && (
                <>
                  <Button className="btn-primary" onClick={handleAddCorrectiveAction}>
                    Add Corrective Action
                  </Button>
                  <Button
                    className="btn-primary"
                    onClick={handleViewCorrectiveAction}
                    style={{ marginLeft: 8 }}
                  >
                    View Corrective Actions
                  </Button>
                  <Button type="default" style={{ marginLeft: 8 }} onClick={handleResolvedClick}>
                    Mark as Resolved
                  </Button>
                </>
              )}

              {complaintDetail.status !== ComplaintStatusEnum.Pending && correctiveCount > 0 && (
                <Button
                  className="btn-primary"
                  onClick={handleViewCorrectiveAction}
                  style={{ marginLeft: 8 }}
                >
                  View Corrective Actions
                </Button>
              )}
            </div>
          </>
        )}
      </Card>
      <Footer />
    </DashboardLayout>
  );
}

export default ComplaintDetail;
